import { Table } from 'foundations-components/transitional/components/Table';
import ResponseFooter from 'developer-docs-shared-components/components/endpoint/ResponseFooter';
import { Text } from 'foundations-components/components/Text';
import { useState } from 'react';
import styled from 'styled-components';
import { StyledHeader } from './common/CardHeader';
import { View } from 'foundations-components/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const StyledTableHead = styled.thead.withConfig({
  displayName: "EndpointJSONFields__StyledTableHead",
  componentId: "sc-11x778w-0"
})(["background-color:", ";"], ({
  theme
}) => theme.color['fill-primary-disabled']);

/**
 * Example children prop (from legacy mdx docs):
 * const children = [
 *   { props: { children: 'JSON Fields returned in the response' } },
 *   {
 *     props: {
 *       children: [
 *         {
 *           props: {
 *             type: 'thead',
 *             children: { type: 'tr' },
 *           },
 *         },
 *         {
 *           props: {
 *             type: 'tbody',
 *             children: [{ type: 'tr' }],
 *           },
 *         },
 *       ],
 *     },
 *   },
 * ];
 */

/*
  Used specifically for legacy/v1 API MDX docs for the JSON Fields returned
  in the response sections. Attempts to mirror the look and feel of the
  EndpointExample component.
*/
const EndpointJSONFields = ({
  children
}) => {
  const [expanded, setExpanded] = useState(false);
  const sectionHeader = children[0].props.children;
  const tableHeaderRow = children[1].props.children[0].props.children;
  const tableBody = children[1].props.children[1];
  return /*#__PURE__*/_jsxs(View, {
    marginBlockEnd: "400",
    children: [/*#__PURE__*/_jsx(StyledHeader, {
      children: /*#__PURE__*/_jsx(Text, {
        as: "h5",
        children: sectionHeader
      })
    }), /*#__PURE__*/_jsxs(Table, {
      flush: true,
      bordered: true,
      height: expanded ? 'auto' : '400px',
      children: [/*#__PURE__*/_jsx(StyledTableHead, {
        children: tableHeaderRow
      }), tableBody]
    }), /*#__PURE__*/_jsx(ResponseFooter, {
      expanded: expanded,
      onClick: () => setExpanded(!expanded)
    })]
  });
};
export default EndpointJSONFields;